<template>
  <div class="people-config" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>姓名</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入姓名" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>手机号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入手机号" v-model="table.search.phone"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>角色</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.role" class="app-block" placeholder="请选择角色">
              <a-select-option :value="1">{{repairPeopleRoleText(1)}}</a-select-option>
              <a-select-option :value="2">{{repairPeopleRoleText(2)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newPeople()">新增人员</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="repair_attendant_id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="deletePeople(data)">移除</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" destroy-on-close centered>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="人员姓名" prop="people">
          <a-select v-model="form.people" placeholder="请选择人员姓名">
            <a-select-option :value="value.id" v-for="value in modal.peopleOptions" :key="value.id">{{value.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="角色" prop="type">
          <a-radio-group v-model="form.type">
            <a-radio :value="1">{{repairPeopleRoleText(1)}}</a-radio>
            <a-radio :value="2">{{repairPeopleRoleText(2)}}</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import {
    repairPeopleRoleText
  } from '@/io/dict.js';
  import CommunityService from '@/io/community.js';
  import PeopleConfigService from '@/io/people_config.js';

  export default {
    name: 'PeopleConfig',
    props: {
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        repairPeopleRoleText,
        table: {
          loading: false,
          search: {
            name: null,
            phone: null,
            role: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '姓名',
              dataIndex: 'repair_attendant_name'
            },
            {
              title: '手机号',
              dataIndex: 'repair_attendant_phone'
            },
            {
              title: '部门',
              dataIndex: 'staffText'
            },
            {
              title: '角色',
              dataIndex: 'repairPeopleRoleText'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        form: {
          people: [],
          type: null
        },
        rules: {
          people: [
            {
              required: true,
              message: '请选择人员姓名'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择角色'
            }
          ]
        },
        modal: {
          peopleOptions: [],
          id: null,
          title: '新增人员',
          show: false,
          loading: false
        }
      }
    },
    watch: {
      communityId: {
        handler(newValue, oldValue) {
          if (newValue || this.$getCookie('communityId')) {
            this.initComunityPeople();
            this.searchTable();
          }
        },
        immediate: true
      }
    },
    methods: {
      confirmModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.modal.loading = true;
          PeopleConfigService.add(this.communityId, this.form.people, this.form.type).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.modal.loading = false;
            this.modal.show = false;
            this.form = {
              people: [],
              type: null
            };
          });
        });
      },
      newPeople() {
        this.modal.show = true;
      },
      deletePeople(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此人员？',
          onOk() {
            PeopleConfigService.del(data.repair_attendant_id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          phone: null,
          role: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initComunityPeople() {
        CommunityService.staff(this.communityId || this.$getCookie('communityId')).then(res => {
          this.modal.peopleOptions = res.map(val => {
            return {
              ...val,
              name: `${val.name}(${val.phone_number})`
            }
          });
        }).catch(err => {});
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        PeopleConfigService.listPage(
          this.communityId,
          this.table.search.name,
          this.table.search.phone,
          this.table.search.role,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.repairPeopleRoleText = repairPeopleRoleText(val.repair_attendant_role);
            val.staffText = val.staff_info.tissue.map(val => val.name).join('、');
            return val;
          });
          this.table.page.total = res.total;
          this.$emit('total', res.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>